/* eslint-disable */
import React from "react";
import { ProfessionalBenefits } from "./partials";

export default class ProductDesigner extends React.Component {
  render () {
    return (
      <div className="container page-container">
        <div className="card">
          <h2 style={{ marginBottom: 20, textAlign: "center" }}>Product Designer - Denver, CO</h2>

          <h4>About Haven Connect</h4>
          <p style={{ fontSize: 15 }}>
            Haven Connect transforms the affordable housing industry by streamlining the application
            process for residents and property managers. Haven Connect uses automation and a deep
            understanding of the regulatory challenges for affordable housing to get low-income
            Americans into units faster {"&"} at a fraction of the cost.
          </p>

          <h4 style={{ marginTop: 40 }}>About You</h4>
          <p style={{ fontSize: 15 }}>
            You care deeply about both improving the lives of Americans with low income and building
            a real, profitable business. You are extremely friendly, eager to jump on the phone with
            customers, and aren’t afraid to roll up your sleeves to clean a spreadsheet, design a
            process, or build a new customer support script.
          </p>

          <h4 style={{ marginTop: 40 }}>What you'll do</h4>
          <p style={{ fontSize: 15 }}>
            <li>
              Can create awesome and visually stunning wireframes, designs, and prototypes to
              improve the experience, look and feel of our product
            </li>
            <li>Can create clickable prototypes in applications like InVision</li>
            <li>Can create a sitemap and is well-verse in information architecture</li>
            <li>Can design interactions across various mediums including web, mobile and email</li>
          </p>

          <h4 style={{ marginTop: 40 }}>Required Skills and Experience</h4>
          <p style={{ fontSize: 15 }}>
            <li>Will improve designs based on user feedback, data, and testing</li>
            <li>Empathizes with our users and takes a user-centered approach to design</li>
            <li>
              3+ years of professional experience designing a web, mobile or other user-centered
              application
            </li>
            <li>
              Strong design skills in Sketch, Photoshop and Illustrator, and Adobe Creative Suite
            </li>
            <li>Experience with HTML, CSS and JavaScript</li>
            <li>
              A portfolio that showcases interaction and visual design projects, user research
            </li>
            <li>Has and a strong grasp of design processes and methodologies</li>
            <li>A Bachelor's or Master's degree in HCI, design, digital media or related field</li>
            <li>
              Bonus: Experience in a web-based property management product or in Google's Material
              Design.
            </li>
          </p>

          <ProfessionalBenefits />

          <p style={{ fontSize: 15 }}>
            Please email resume or LinkedIn profile to{" "}
            <a href="mailto:hiring@havenconnect.com">hiring@havenconnect.com</a>
          </p>
        </div>
      </div>
    );
  }
}
